import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import LocalizationService from '../../../../services/LocalizationService'
import { GlobalTextField } from '../../../Core/Input/ControlledTextField'

export const OwnerAddressSection = () => {
  const methods = useFormContext()
  const zipcodeRegex = new RegExp(FirebaseService.getValue(FirebaseConfigKey.ZIPCODE_REGEX))

  return (
    <React.Fragment>
      <Grid container spacing={3} className="margin-top-small">
        <Grid item xs={12} md={6}>
          <Typography className="grey">{'Address'}</Typography>
          <GlobalTextField
            fullWidth
            name="addressline1"
            inputRef={methods.register({ required: true })}
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.addressline1 && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className="grey">{'Address line 2'}</Typography>
          <GlobalTextField
            fullWidth
            name="addressline2"
            inputRef={methods.register({ required: false })}
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.addressline2 && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className="grey">{'City'}</Typography>
          <GlobalTextField
            fullWidth
            name="city"
            inputRef={methods.register({ required: true })}
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.city && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className="grey">{'State'}</Typography>
          <GlobalTextField
            disabled
            fullWidth
            name="state"
            inputRef={methods.register({ required: true })}
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.state && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className="grey">{LocalizationService.STRINGS.zipcode}</Typography>
          <GlobalTextField
            fullWidth
            name="zip_code"
            inputRef={methods.register({ required: true, validate: x => zipcodeRegex.test(x) })}
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.zip_code && `${LocalizationService.STRINGS.zipcode} must be 5 digits`}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
